import { PAYMENT_OPEN, SEASON_START } from "../../../common/flags";
import React, { useState, useEffect } from "react";
import Typography from "../../../components/ui/typography";
import classNames from "../manage.module.css";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "../../../components/ui/button";
import Box from "@material-ui/core/Box";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { SET_SELECTED_STUDENTS_FOR_MULTIPLE_PAYMENT } from "../../../store/actionTypes";
import {
  Checkbox,
  FormControlLabel,
  LinearProgress,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { GoogleFormsLink } from "./objectionBox";
import * as XLSX from "xlsx";
import { personalExamLink } from "./generateLinks.jsx";

// Bu sezon bilgilerini onaylamış (aktif) öğrenci. Ödeme sadece bunlar için yapılabilir.
const isActiveThisSeason = (student) =>
  !!student.info_confirmed_at &&
  new Date(student.info_confirmed_at) >= SEASON_START;

export const TbSection = ({
  user,
  didStudentPay,
  studentList,
  users_of_this_school,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const [redirectPage, setRedirectPage] = useState("");
  const [selectedStudents, setSelectedStudents] = useState({});
  const [studentFilter, setStudentFilter] = useState("active"); // "active" | "all"
  const refLoginUsersTeamId = React.useRef(1);

  useEffect(() => {
    setIsLoading(true);

    if (user?.role === 0 && users_of_this_school) {
      // Bu öğrenci sadece kendi takımındaki elemanları görecek, bu nedenle önce öğrencinin takım id'sini bulalım:
      let myTeamId = 1;
      for (let i = 0; i < users_of_this_school.length; i++) {
        if (users_of_this_school[i].id === user.id) {
          myTeamId = users_of_this_school[i].exam_results.find(
            (er) => er.season === "2026_tb",
          )?.team_id;
          refLoginUsersTeamId.current = myTeamId;
          break;
        }
      }
    }

    setIsLoading(false);
  }, [studentList, users_of_this_school]);
  const dispatch = useDispatch();
  // Öğretmenin sınıflarında aynı ad soyadla açılmış birden fazla hesap (backend: DuplicateUserManager).
  // Admin önizlemesinde okulun tamamı geldiği için öğretmenin sınıflarına göre süzüyoruz.
  const coachClassIds = (user?.all_coaches_of_this_school || [])
    .filter((c) => c.id === user.id)
    .map((c) => c.class_id);
  const duplicateGroups = useSelector(
    (state) => state.generic.duplicate_groups || [],
  ).filter((g) => coachClassIds.includes(g.class_id));
  const duplicateUserIds = new Set(
    duplicateGroups.flatMap((g) => g.users.map((u) => u.id)),
  );
  // Çift kayıt nedeniyle ödemesi kapalı öğrenciler (ödenmiş başka hesabı var ya da admin kapattı) seçilemez.
  const paymentBlocks = useSelector(
    (state) => state.generic.payment_blocks || {},
  );

  if (!didStudentPay && user?.role === 0) return null;

  const activeStudentCount = studentList.filter(isActiveThisSeason).length;
  const visibleStudentList =
    user?.role === 1 && studentFilter === "active"
      ? studentList.filter(isActiveThisSeason)
      : studentList;

  const onPurchaseClickedForSelectedStudents = () => {
    // Güvenlik için: sadece aktif ve ödemesi kapalı olmayan öğrenciler ödemeye gönderilir.
    const activeIds = new Set(
      studentList
        .filter((s) => isActiveThisSeason(s) && !paymentBlocks[s.user_id])
        .map((s) => String(s.user_id)),
    );
    dispatch({
      type: SET_SELECTED_STUDENTS_FOR_MULTIPLE_PAYMENT,
      payload: Object.keys(selectedStudents).filter((id) => activeIds.has(id)),
    });
    setRedirectPage("/satinal");
  };

  const exportToExcel = () => {
    // Excel için veri hazırlama
    const excelData = visibleStudentList.map((student, index) => ({
      "Sıra No": index + 1,
      ID: student.user_id,
      "Ad-Soyad": student.name,
      "E-Posta": student.email,
      Sınıf: student.class_id,
      Durum: isActiveThisSeason(student) ? "Aktif" : "Aktif değil",
      "Ücret Durumu": student.is_paid ? "Ödendi" : "Ödenmedi",
    }));

    // Excel çalışma kitabı oluşturma
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Öğrenci Listesi");

    // Dosya adı oluşturma (tarih ile)
    const today = new Date();
    const dateString = today.toISOString().split("T")[0];
    const fileName = `ogrenci_listesi_${dateString}.xlsx`;

    // Excel dosyasını indirme
    XLSX.writeFile(wb, fileName);
  };

  const studentTableTB = (
    <Box sx={{ overflow: "auto" }}>
      {/* Excel İndirme Butonu - Sadece öğretmenler için */}
      {user.role === 1 && (
        <Box
          sx={{
            background: "#2a3b4d",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "20px",
          }}
        >
          <Typography
            style={{
              color: "#fff",
              marginBottom: "16px",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            Bu dosya sistemde kayıtlı olan öğrencilerinizin listesini
            içermektedir.
          </Typography>
          <Typography
            style={{
              color: "orange",
              fontStyle: "italic",
              marginBottom: "16px",
              fontSize: "15px",
            }}
          >
            Not: Aktif öğrencileriniz, yeni sezon için bilgilerini onaylayarak
            hesabını aktif hale getiren öğrencilerinizdir. Ödeme yalnızca aktif
            öğrencileriniz için yapılabilir. Aktif olmayan öğrencilerinizin
            sisteme giriş yapıp "Bilgilerim güncel" onayını vermesi
            gerekmektedir.
          </Typography>
          <RadioGroup
            row
            value={studentFilter}
            onChange={(e) => setStudentFilter(e.target.value)}
            style={{ marginBottom: "16px" }}
          >
            <FormControlLabel
              value="active"
              control={<Radio style={{ color: "#ff8c00" }} />}
              label={`Aktif Öğrencilerim (${activeStudentCount})`}
              style={{ color: "#fff" }}
            />
            <FormControlLabel
              value="all"
              control={<Radio style={{ color: "#ff8c00" }} />}
              label={`Tüm Öğrencilerim (${studentList.length})`}
              style={{ color: "#fff" }}
            />
          </RadioGroup>
          <Button
            onClick={exportToExcel}
            style={{
              backgroundColor: "#ff8c00",
              color: "white",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "bold",
              transition: "background-color 0.3s",
            }}
          >
            Öğrenci Listesini Excel Olarak İndir
          </Button>
        </Box>
      )}
      <Box sx={{ width: "100%", display: "table", tableLayout: "fixed" }}>
        <TableContainer component={Paper}>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "40px",
                backgroundColor: "#fff",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div
                  className="loading-spinner"
                  style={{
                    border: "4px solid #f3f3f3",
                    borderTop: "4px solid #3498db",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 20px auto",
                  }}
                />
                <Typography style={{ color: "#666" }}>
                  Veriler yükleniyor...
                </Typography>
              </div>
            </Box>
          ) : (
            <Table aria-label="a dense table">
              <TableHead>
                <TableRow
                  style={{
                    background: "#e95914",
                    padding: "12px 16px",
                    margin: "16px 0 0 0",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {[
                    { name: "Yarışmacı ID", align: "center" },
                    { name: "Adı Soyadı", align: "center" },
                    { name: "E-Posta", align: "center", hideForThisRole: 0 },
                    { name: "Sınıf", align: "center", hideForThisRole: 0 },
                    // { name: "T.B Sınavı Puanı", align: "center" },
                    // { name: "TR Sırası", align: "center" },
                    // {
                    //   name: "Sınav Linki",
                    //   align: "center",
                    //   hideForThisRole: 0,
                    // },
                    {
                      name: "Ücret Durumu",
                      align: "center",
                      hideForThisRole: 0,
                    },
                    { name: "Seç", align: "center", hideForThisRole: 0 },
                  ].map(
                    (row) =>
                      row.hideForThisRole !== user.role && (
                        <TableCell
                          key={row.name + "_user_list_column_name"}
                          style={{ fontWeight: "bold", color: "white" }}
                          align={row.align}
                        >
                          {row.name}
                        </TableCell>
                      ),
                  )}
                </TableRow>
              </TableHead>

              {/*Takım Belirleme işleminde bu table kullanılacak */}
              <TableBody>
                {(() => {
                  // Benzersiz team_id'leri topla
                  const uniqueTeamIds = new Set();
                  studentList.forEach((row) => {
                    const tb_2026_result =
                      row?.exam_results.find((r) => r.season === "2026_tb") ??
                      {};
                    if (tb_2026_result.team_id) {
                      uniqueTeamIds.add(tb_2026_result.team_id);
                    }
                  });
                  let lastTeamId = null;

                  // Öğrenci listesini team_id'ye göre sırala
                  const sortedStudentList = [...visibleStudentList].sort((a, b) => {
                    const aResult =
                      a?.exam_results?.find((r) => r.season === "2026_tb") ??
                      {};
                    const bResult =
                      b?.exam_results?.find((r) => r.season === "2026_tb") ??
                      {};

                    const aTeamId = aResult.team_id || "ZZZZZZ";
                    const bTeamId = bResult.team_id || "ZZZZZZ";

                    // Takım ID'lerini parçalara ayır
                    const [aClass = "Z", aSchool = "Z", aTeam = "Z"] =
                      aTeamId.split("-");
                    const [bClass = "Z", bSchool = "Z", bTeam = "Z"] =
                      bTeamId.split("-");

                    // Önce sınıfa göre sırala
                    if (aClass !== bClass) {
                      return aClass.localeCompare(bClass);
                    }

                    // Sonra takım numarasına göre sırala
                    return parseInt(aTeam) - parseInt(bTeam);
                  });

                  return sortedStudentList.map((row) => {
                    if (!row.is_paid && user.role !== 1) return null;

                    const tb_2026_result =
                      row?.exam_results.find((r) => r.season === "2026_tb") ??
                      {};

                    if (
                      user.role === 0 &&
                      refLoginUsersTeamId.current !== tb_2026_result.team_id
                    )
                      return null;

                    const rowStyle =
                      user.role === 1
                        ? {
                            borderBottom: "1px solid rgba(224, 224, 224, 1)",
                            borderLeft: "3px solid #666",
                            backgroundColor: tb_2026_result.team_id
                              ? "#fafafa"
                              : "transparent",
                          }
                        : {};

                    // Takım bilgisini parçala ve anlamlı metin oluştur
                    const getTeamInfo = (teamId) => {
                      if (!teamId) return "Atanmadı";
                      const [sinif, okul, takim] = teamId.split("-");
                      return `${sinif}. Sınıflar - ${takim}. Takım`;
                    };

                    // Takım bilgisini sadece değiştiğinde göster
                    const showTeamInfo = tb_2026_result.team_id !== lastTeamId;

                    // Takım bilgisi satırı
                    const teamHeaderRow =
                      showTeamInfo && tb_2026_result.team_id ? (
                        <TableRow>
                          <TableCell
                            colSpan={user.role === 1 ? 8 : 8}
                            style={{
                              backgroundColor: "#f0f0f0",
                              borderTop: "2px solid #666",
                              borderBottom: "2px solid #666",
                              padding: "12px 16px",
                              fontWeight: "bold",
                              fontSize: "1em",
                              textAlign: "center",
                              color: "#333",
                            }}
                          >
                            {getTeamInfo(tb_2026_result.team_id)}
                          </TableCell>
                        </TableRow>
                      ) : null;

                    lastTeamId = tb_2026_result.team_id;
                    return (
                      <React.Fragment key={row.user_id + "user_id"}>
                        {/* {teamHeaderRow} */}
                        <TableRow style={rowStyle}>
                          <TableCell align="center">{row.user_id}</TableCell>
                          <TableCell
                            align="center"
                            style={
                              user.role === 1 && duplicateUserIds.has(row.user_id)
                                ? { color: "#c62828", fontWeight: "bold" }
                                : undefined
                            }
                          >
                            {row.name}
                            {user.role === 1 &&
                              duplicateUserIds.has(row.user_id) &&
                              " ⚠ Çift kayıt"}
                          </TableCell>
                          {user.role === 1 && (
                            <TableCell align="left">{row.email}</TableCell>
                          )}
                          {user.role === 1 && (
                            <TableCell
                              align="center"
                              style={{ margin: 0, padding: 0 }}
                            >
                              {row.class_id}
                            </TableCell>
                          )}
                          {/* <TableCell align="center">
                            {tb_2026_result.score == null
                              ? "Sınava katılmadı"
                              : tb_2026_result.score}
                          </TableCell>
                          {user.role === 1 && (
                            <TableCell
                              align="center"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}
                            >
                              {personalExamLink({
                                usr: row,
                                buttonName: "T.B. Sınavı",
                                size: "small",
                                season: "tb_2526",
                              })}
                            </TableCell>
                          )} */}
                          {user.role === 1 && (
                            <TableCell align="center">
                              {row.is_paid ? "ÖDENDİ" : "Ödenmedi"}
                            </TableCell>
                          )}
                          <TableCell align="center">
                            {PAYMENT_OPEN &&
                              !row.is_paid &&
                              user.role === 1 &&
                              !isActiveThisSeason(row) && (
                                <span style={{ color: "#999", fontSize: 12 }}>
                                  Aktif değil
                                </span>
                              )}
                            {PAYMENT_OPEN &&
                              !row.is_paid &&
                              user.role === 1 &&
                              isActiveThisSeason(row) &&
                              paymentBlocks[row.user_id] && (
                                <span
                                  style={{ color: "#c62828", fontSize: 12 }}
                                  title={paymentBlocks[row.user_id].message}
                                >
                                  Ödeme kapalı (çift kayıt)
                                </span>
                              )}
                            {PAYMENT_OPEN &&
                              !row.is_paid &&
                              user.role === 1 &&
                              isActiveThisSeason(row) &&
                              !paymentBlocks[row.user_id] && (
                              <Checkbox
                                checked={!!selectedStudents[row.user_id]}
                                onChange={(e) => {
                                  let tempSelectedStudents = { ...selectedStudents };
                                  if (e.target.checked) {
                                    tempSelectedStudents[row.user_id] = true;
                                  } else {
                                    delete tempSelectedStudents[row.user_id];
                                  }

                                  setSelectedStudents(tempSelectedStudents);
                                }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  });
                })()}
              </TableBody>

              {/*Ödemeler açıldığında bu tablo kullanılacak*/}
              {/* <TableBody>
                {studentList.map((row) => {
                  //Ödeme yapmayanları listeden gizler
                  // if (!row.is_paid) return null;

                  return (
                    <TableRow key={row.user_id + "user_id"}>
                      <TableCell align="center">{row.user_id}</TableCell>
                      <TableCell align="center">{row.name}</TableCell>
                      <TableCell align="center">{row.email}</TableCell>
                      {user.role === 1 && (
                        <TableCell
                          align="center"
                          style={{ margin: 0, padding: 0 }}
                        >
                          {" "}
                          {row.class_id}
                        </TableCell>
                      )}

                      {user.role === 1 && (
                        <TableCell align="center">
                          {personalExamLink({
                            usr: row,
                            buttonName: "T.B. Sınavı",
                            size: "small",
                            season: "tb_2526",
                          })}
                        </TableCell>
                      )} 
                   {user.role === 1 && (
                        <TableCell align="center">
                          {row.class_id
                            ? generatePersonalExamLink({
                                usr: row,
                                buttonName: "Deneme Sınavı",
                                season: "dnm_2026",
                                size: "small",
                              })
                            : "Sınıf bilgisi eksik"}
                        </TableCell>
                      )} 
                    {user.role === 1 && (
                        <TableCell align="center">
                          {row.is_paid ? "Ödendi" : "Ödenmedi"}
                        </TableCell>
                      )}
                      {!row.is_paid && user.role === 1 && (
                        <TableCell align="center">
                          <Checkbox
                            onChange={(e) => {
                              let tempSelectedStudents = {
                                ...selectedStudents,
                              };
                              if (e.target.checked) {
                                tempSelectedStudents[row.user_id] = true;
                              } else {
                                delete tempSelectedStudents[row.user_id];
                              }

                              setSelectedStudents(tempSelectedStudents);
                            }}
                          />
                        </TableCell>
                      )} 
                    </TableRow>
                  );
                })}
              </TableBody> */}
            </Table>
          )}
          {PAYMENT_OPEN && Object.keys(selectedStudents).length > 0 && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
                margin: 2,
              }}
            >
              <Button
                style={{ padding: 5 }}
                onClick={onPurchaseClickedForSelectedStudents}
              >
                {"Seçilen " +
                  Object.keys(selectedStudents).length +
                  " Yarışmacı İçin Ödeme Yap"}
              </Button>
            </div>
          )}
        </TableContainer>
      </Box>
    </Box>
  );

  if (redirectPage) return <Redirect to={redirectPage} />;

  const itirazFormu = (
    <GoogleFormsLink
      buttonName="Sorulara ve Cevaplarına İtirazlar"
      formLink={
        "https://docs.google.com/forms/d/e/1FAIpQLSexEx9Nri4s5pi5P5nfxbEX87LK6cDL5aqUwRBQ5yZON6vaog/viewform?usppp_url&entry.1157331533=" +
        user.id +
        "&entry.427270648=" +
        user.email +
        "&entry.1902692000=" +
        user.class_id
      }
      description="Bu formdan sadece puanlara dair itirazlar kabul edilmektedir.Son itiraz tarihi 22 Şubat 2026 Pazar saat 23.59 ' dur. Bu tarihten sonra sorulara yapılacak itirazların değerlendirmeye alınmayacağını belirtmek isteriz."
    />
  );
  return (
    <div className={"card " + classNames.left_step}>
      <Typography size="small" color="white" font="tadao" weight="normal">
        {user.role === 1 ? "ÖĞRENCİLERİM" : "TAKIM BELİRLEME SINAVI"}
      </Typography>

      {user.role === 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          {/* <Typography
            style={{
              fontStyle: "italic",
              color: "orange",
              marginTop: 10,
              fontSize: "16px",
            }}
          >
            {
              "Kayıt işleminiz tamamlanmıştır. Lütfen sınava başlamadan önce okul/sınıf bilgilerinizi kontrol ediniz. Hata varsa düzeltiniz. Bilgilerinizin hatalı olması durumunda diskalifiye edilebilirsiniz."
            }
          </Typography> */}
          <Typography
            style={{
              fontStyle: "italic",
              color: "orange",
              marginTop: 10,
              fontSize: "16px",
              marginBottom: 20,
              lineHeight: 1.6,
            }}
          >
            Takım Belirleme Sınavı tamamlanmıştır ve puanlarınız sınav
            sayfanızda açıklanmıştır. Bu sınav sonucuna göre takımlar
            oluşturulmuştur. Hangi takıma dahil olduğunuzu
            <strong> İl Finalleri Sınavı</strong> bölümünden
            görüntüleyebilirsiniz. Bu sınavda hiçbir yarışmacı elenmemiştir; tüm
            katılımcılar, aldıkları puanlara göre takımlara yerleştirilmiştir.
            Takımınız tek kişiden oluşuyorsa, İl Finalleri sınavına bireysel
            olarak katılacak ve kendi başınıza soruları tamamlayacaksınız.
          </Typography>
          {user.role === 0 && (
            <>
              {personalExamLink({
                usr: user,
                buttonName: "Takım Belirleme Sınavı",
                season: "tb_2526",
              })}
            </>
          )}
        </div>
      )}
      {user.role === 1 && (
        <div
          style={{
            width: "100%",

            marginTop: 10,
          }}
        >
          {/* <Typography
            style={{
              fontStyle: "italic",
              color: "#FF8C00",
              marginTop: 10,
              fontSize: "16px",
              marginBottom: 20,
              lineHeight: 1.6,
            }}
          >
            Öğrencilerinizin Takım Belirleme Sınavı puanları açıklanmıştır.
            Öğrencileriniz, kendi sınav sayfalarından aldıkları puanları
            görebilirler.
          </Typography> */}
          {/* <Typography
            style={{
              color: "#fff",
              background: "#2a3b4d",
              borderRadius: 8,
              padding: "12px 16px",
              margin: "16px 0 0 0",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {
              "○ Öğretmenler, sorumlu oldukları sınıfı seçmekle yükümlüdür. Lütfen sınıf seçimini yapmayı unutmayınız."
            }
            <br />
            {
              "○ Sınıf seçimi yapmayan öğrencileriniz bu listede görünmez. Lütfen öğrencilerinizi bu konuda bilgilendiriniz."
            }
            <br /> */}
          {/* {
              "○ Öğrencileriniz için kurum adına ödeme yapmak istiyorsanız, işlemi kurumun bilgisi dahilinde ve kurumun kart bilgileriyle gerçekleştirmelisiniz."
            } */}
          {/* </Typography> */}
        </div>
      )}
      {/* {itirazFormu} */}

      {/* Tablo sadece öğretmenler (role 1) için gösterilir */}
      {user.role === 1 && duplicateGroups.length > 0 && (
        <div
          style={{
            marginTop: 20,
            padding: "12px 16px",
            borderRadius: 8,
            background: "#fff3e0",
            borderLeft: "6px solid #e65100",
            color: "#333",
            fontSize: 15,
            lineHeight: 1.6,
          }}
        >
          <strong>⚠ Olası çift kayıt</strong>
          <div>
            Aşağıdaki öğrenciler için aynı ad soyadla (aynı sınıfta ya da aynı
            telefon numarasıyla) birden fazla hesap bulunmaktadır. Aynı öğrenci
            için iki kez ödeme yapmamak için ödeme öncesinde kontrol ediniz.
            Ödemesi yapılmış başka hesabı olan öğrencinin diğer hesaplarında
            ödeme kapatılmıştır. Fazla hesabın silinmesi için
            info@tzv.org.tr adresine e-posta gönderebilirsiniz.
          </div>
          <ul style={{ margin: "8px 0 0 0", paddingLeft: 20 }}>
            {duplicateGroups.map((g) => (
              <li key={g.users.map((u) => u.id).join("-")}>
                <strong>
                  {g.name} ({g.class_id}. sınıf)
                </strong>
                {": "}
                {g.users
                  .map(
                    (u) =>
                      "ID " +
                      u.id +
                      " - " +
                      u.email +
                      (u.class_id !== g.class_id ||
                      u.school_name !== g.users[0].school_name
                        ? " (" + u.school_name + ", " + u.class_id + ". sınıf)"
                        : "") +
                      (u.is_paid ? " (ödendi)" : " (ödenmedi)"),
                  )
                  .join(", ")}
              </li>
            ))}
          </ul>
        </div>
      )}
      {user.role === 1 && <div style={{ marginTop: 20 }}>{studentTableTB}</div>}
    </div>
  );
};
